export default __webpack_public_path__ + "static/media/ns-arrow.b6c4d3e2.svg";